module.exports = __webpack_public_path__ + "static/index/assets/img/header_log.ff92e07a.png";